import apiClient from './client';

// ─── Typen ──────────────────────────────────────────────────────────────────

export interface TreeNode {
  id: string;
  firstName: string;
  lastName: string | null;
  birthDateText: string | null;
  deathDateText: string | null;
  birthPlace: string | null;
  deathPlace: string | null;
  gender: string | null;
  profileMediaId: string | null;
  profileMediaFilename: string | null;
  primaryParentId: string | null;
  secondaryParentId: string | null;
}

export interface TreeLink {
  id: string;
  person1Id: string;
  person2Id: string;
  type: string; // 'married' | 'partnership' | 'divorced' | 'separated'
  startDate: string | null;
  endDate: string | null;
  startPlace: string | null;
}

export interface TreeData {
  nodes: TreeNode[];
  links: TreeLink[];
}

// ─── API-Funktionen ─────────────────────────────────────────────────────────

/** Gesamter Baum (Nodes + Links) */
export async function getTree(): Promise<TreeData> {
  const { data } = await apiClient.get<TreeData>('/tree');
  return data;
}

/** Teilbaum ab einer Person */
export async function getSubtree(personId: string, depth: number = 3): Promise<TreeData> {
  const { data } = await apiClient.get<TreeData>(`/tree/subtree/${personId}`, {
    params: { depth },
  });
  return data;
}

/** Gesamten Stammbaum löschen (Admin) */
export async function deleteEntireTree(): Promise<void> {
  await apiClient.delete('/tree');
}
